import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { clearAuthSession } from "../../constants/authSession";

function Logout({ history }) {
  useEffect(() => {
    clearAuthSession();
    history.replace("/");
    window.location.reload();
  }, [history]);

  return null;
}

export default withRouter(Logout);
